import {Component, Object3D, WonderlandEngine} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {vec3} from 'gl-matrix';
import {TimeKeeper} from './time-keeper.js';

/**
 * animate-flower
 */
export class AnimateFlower extends Component {
    static TypeName = 'animate-flower';

    @property.float()
    fullScale: number;

    worldPosition: vec3 = vec3.create();
    timeKeeper!: TimeKeeper;

    start() {
        this.object.getPositionWorld(this.worldPosition);
    }

    time = 0;

    update(dt: number) {
        this.time += dt;
        const scale = Math.pow((Math.sin(this.time) + 1.0) * 0.5, 0.5) * this.fullScale;
        this.object.setScalingLocal([scale, scale, scale]);
    }
}
